<template>
  <template v-if="hint">
    <slide-up-down-fi
      :model-value="!isCollapsed"
      :duration="300"
    >
      <div
        :class="{
          'quantity-modification-hint-fi': true,
          [`quantity-modification-hint-fi--active`]: !isCollapsed,
          [`quantity-modification-hint-fi--theme-${theme}`]: theme.length,
        }"
        data-test="modification-hint"
        :data-test-2="dataTest2"
      >
        <icon-fi
          class="quantity-modification-hint-fi__icon"
          :icon="icon"
        />
        {{ hint }}
        <icon-fi
          class="quantity-modification-hint-fi__icon-close"
          icon="close"
          @click="isCollapsed = true"
        />
      </div>
    </slide-up-down-fi>
  </template>
</template>

<script>
import IconFi from '@/components/atoms/icon-fi/IconFi.vue';
import SlideUpDownFi from '@/components/atoms/slide-up-down-fi/SlideUpDownFi.vue';

export default {
  name: 'QuantityModificationHintFi',
  components: {
    IconFi,
    SlideUpDownFi,
  },
  props: {
    hint: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'info',
    },
    theme: {
      type: String,
      default: '',
    },
    dataTest2: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isCollapsed: true,
    };
  },
  async mounted() {
    await this.$nextTick();
    this.isCollapsed = false;
  },
};
</script>

<style scoped src="./quantity-modification-hint-fi" />
